import { LOCALES } from './locales-constants';

export default {
  [LOCALES.ARABIC]: {
    operations: 'التشغيل',
    configuration: 'الإعدادات',
    zoning: 'منتجات التعريفة',
    welcome: 'أهلا',
    selectStatement: 'اختر واحد من الأنظمة المتاحة أدناه',
    login: 'تسجيل الدخول',
    logout: 'تسجيل الخروج',
    eazyMobility: 'ايزي موبيليتي',
    routes: 'المسارات',
    englishName: 'الاسم بالانجليزية',
    arabicName: 'الاسم بالعربية',
    code: 'الكود',
    groups: 'المجموعات',
    organization: 'الشركة',
    customerSupport: 'دعم العملاء',
    fareMediaInquery: 'استعلام وسائل دفع التعريفة',
    actions: 'الأدوات',
    addRoute: 'إضافة مسار',
    loginHint: 'برجاء تسجيل الدخول',
    userName: 'اسم المستخدم',
    password: 'كلمة السر',
    addOrganization: 'إضافة شركة',
    pageNotFound: 'صفحة غير موجودة',
    notExist: 'عفوا، هذه الصفحة غير موجودة',
    goToHome: 'الذهاب للصفحة الرئسية',
    status: 'الحالة',
    drivers: 'السائقين',
    admins: 'مستخدمي المنظومة',
    organizations: 'الشركات',
    delete: 'حذف',
    confirmDeleteMessage: 'هل أنت متأكد أنك تريد حذف',
    AreYouSureDelete: 'هل أنت متأكد من حذف هذا السجل؟',
    route: 'مسار',
    cancel: 'إلغاء',
    enabled: 'مفعل',
    update: 'تحديث',
    edit: 'تعديل',
    editRoute: 'تعديل مسار',
    createRoute: 'إضافة مسار جديد',
    create: 'إضافة',
    routeInfo: 'بيانات المسار',
    noGroups: 'لا توجد جروبات معينة لهذا المسار بعد',
    back: 'عودة',
    saveGroups: 'حفظ المجموعات',
    createOrganization: 'إضافة شركة جديدة',
    editOrganization: 'تعديل الشركة',
    oranizationInfo: 'بيانات الشركة',
    name: 'الاسم',
    lastLogin: 'آخر دخول',
    addAdmin: 'إضافة',
    editAdmin: 'تعديل',
    email: 'ايميل',
    phone: 'رقم التليفون',
    firstName: 'الاسم الأول',
    lastName: 'الاسم الأخير',
    repeatPassword: 'إعادة كلمة السر',
    somethingWrong: 'حدث خطأ',
    mwaslatMasrSuperDASH: 'مواصلة.تك  سوبر داش',
    adminInfo: 'بيانات الأدمن',
    masterConfiguration: 'الإعدادات',
    component: 'المكون',
    permissionType: 'نوع الصلاحية',
    save: 'حفظ',
    operationsOrganizationLevel: 'العمليات علي مستوي الشركة',
    requiredValidation: 'هذا الحقل مطلوب',
    passwordMatchValidation: 'إعادة كلمة السر يحب أن تطابق كلمة السر',
    validEmailValidation: 'صيغة الايميل ليست صحيحه',
    addDriver: 'إضافة سائق',
    searchByName: 'البحث عن طريق الإسم',
    driverInfo: 'معلومات السائق',
    nationalId: 'الرقم القومي',
    licenseNumber: 'رقم الرخصة',
    backToDriversList: 'عودة لقائمة السائقين',
    driver: 'السائق',
    import: 'حمل',
    export: 'تنزيل',
    successEditDriverMessage: 'لقد قمت بتحديث بيانات السائق بنجاح!',
    editDriver: 'تعديل سائق',
    organizationId: 'رقم الشركة',
    show: 'اظهر',
    jumpToPage: 'إلى الصفحة',
    addToGroups: 'إضافة إلى مجموعات',
    clearGroups: 'حذف من مجموعات',
    enable: 'تفعيل',
    disable: 'تعطيل',
    add: 'إضافة',
    reset: 'إعادة تعيين',
    filter: 'تصفية',
    filters: 'وسائل التصفية',
    group: 'مجموعة',
    all: 'الكل',
    apply: 'بحث',
    disabled: 'غير مفعل',
    confirmenableMessage: 'هل أنت متأكد من انك تريد تفعيل',
    confirmdisableMessage: 'هل أنت متأكد من انك تريد تعطيل',
    confirmassignMessage:
      'هل أنت متأكد من انك تريد إضافة إلى المجموعات المختاره',
    confirmclearGroupsMessage: 'هل أنت متأكد من انك تريد حذف من المجموعات',
    confirm: 'تأكيد',
    noOrganization: 'لا توجد شركات',
    selectAll: 'أختر الكل',
    noGroupsFound: 'لا توجد مجموعات',
    successAddDriver: 'تم إضافة سائق بنجاح',
    successAddRoute: 'تم إضافة مسار بنجاح',
    successAddOrganization: 'تم إضافة شركه بنجاح',
    successAddAdmin: 'تم إضافة أدمن بنجاح',
    successEditDriver: 'لقد قمت بتحديث بيانات سائق بنجاح!',
    successEditRoute: 'لقد قمت بتحديث بيانات مسار بنجاح!',
    successEditOrganization: 'لقد قمت بتحديث بيانات شركه بنجاح!',
    successEditAdmin: 'لقد قمت بتحديث بيانات أدمن بنجاح!',
    nationalIdMaxValidationMsg: 'Must be maximum 15 digits',
    digitsOnly: 'Must be only digits',
    phoneMaxValidationMsg: 'Must be maximum 11 digits',
    editProfile: 'تعديل البيانات',
    changePassword: 'تغيير كلمة السر',
    editMyProfile: 'تعديل بياناتي',
    currentPassword: 'كلمه السر الحالية',
    newPassword: 'كلمه السر الجديدة',
    confirmPassword: 'تأكيد كلمه السر الجديدة',
    changePasswordRoles: 'من اجل حماية حسابك، كلمة السر يجب ان تحتوى على:',
    passwordCharacterLength: '6 or more characters',
    passwordValidationLetter: 'At least one letter',
    passwordValidationDigits: 'At least one number',
    successdeletedriver: 'تم حذف السائق بنجاح',
    noResultYet: 'لا توجد نتائج',
    noResultNote: 'سوف يظهر نتائج بمجرد الإضافة',
    addBtn: 'أضف',
    backToOrganizationList: 'عودة لقائمة الشركات',
    backToRoutesList: 'عودة لقائمة المسارات',
    regeneratePassword: 'إعادة تعيين كلمة السر',
    successRegeneratedPassword: 'تم إعادة تعيين كلمة السر بنجاح',
    clearAll: 'حذف الكل',
    restricted: 'محظور',
    fares: 'الأسعار',
    discountTypes: 'أنواع الخصومات',
    AddDiscountType: 'إضافة نوع خصم',
    AddNewDiscountType: 'إضافة نوع خصم جديد',
    EditDiscountType: 'تعديل نوع الخصم',
    DiscountTypeInfo: 'معلومات نوع الخصم',
    DiscountTypeCreatedSuccessfully: 'تم إنشاء نوع الخصم بنجاح',
    DiscountTypeUpdatedSuccessfully: 'تم تحديث نوع الخصم بنجاح',
    BackToDiscountTypes: 'العودة إلى أنواع الخصومات',
    NameEnglish: 'الاسم (إنجليزي)',
    NameArabic: 'الاسم (عربي)',
    SearchDiscountTypePlaceholder: 'البحث بالكود أو الاسم',
    AreYouSureDeleteDiscountType: 'هل أنت متأكد أنك تريد حذف نوع الخصم هذا؟',
    PassengerCategories: 'فئات الركاب',
    AddPassengerCategory: 'إضافة فئة ركاب',
    AddNewPassengerCategory: 'إضافة فئة ركاب جديدة',
    EditPassengerCategory: 'تعديل فئة الركاب',
    PassengerCategoryInfo: 'معلومات فئة الركاب',
    PassengerCategoryCreatedSuccessfully: 'تم إنشاء فئة الركاب بنجاح',
    PassengerCategoryUpdatedSuccessfully: 'تم تحديث فئة الركاب بنجاح',
    SearchPassengerCategoryPlaceholder: 'البحث بالكود أو الاسم',
    AreYouSureDeletePassengerCategory: 'هل أنت متأكد أنك تريد حذف فئة الركاب هذه؟',
    PassengersGroups: 'مجموعات الركاب',
    AddPassengersGroup: 'إضافة مجموعة',
    AddNewPassengersGroup: 'إضافة مجموعة جديدة',
    EditPassengersGroup: 'تعديل مجموعة',
    PassengersGroupInfo: 'معلومات المجموعة',
    IsDefaultGroup: 'تعيين كمجموعة افتراضية (المجموعة الاحتياطية للمؤسسة)',
    PassengersGroupCreatedSuccessfully: 'تم إنشاء المجموعة بنجاح',
    PassengersGroupUpdatedSuccessfully: 'تم تحديث المجموعة بنجاح',
    SearchPassengersGroupPlaceholder: 'البحث باسم المجموعة...',
    AreYouSureDeletePassengersGroup: 'هل أنت متأكد أنك تريد حذف هذه المجموعة؟',
    GroupName: 'اسم المجموعة',
    Users: 'المستخدمون',
    UserInfo: 'بيانات المستخدم',
    Phone: 'رقم الهاتف',
    Email: 'البريد الإلكتروني',
    points: 'النقاط',
    wallet_balance: 'رصيد المحفظة',
    LinkedFareMedia: 'وسائل الدفع المرتبطة',
    Relation: 'النوع',
    Own: 'خاصة',
    Child: 'تابعة',
    SearchUserPlaceholder: 'ابحث بالاسم أو الهاتف أو البريد',
    ChangePassengerGroup: 'تغيير مجموعة الراكب',
    UserGroupUpdated: 'تم تحديث مجموعة الراكب للمستخدم بنجاح',
    EligibilityDocuments: 'مستندات الأهلية',
    AddEligibility: 'إضافة مستند أهلية',
    EligibilityAdded: 'تمت إضافة مستند الأهلية بنجاح',
    EligibilityUpdated: 'تم تحديث مستند الأهلية بنجاح',
    EligibilityDeleted: 'تم حذف مستند الأهلية بنجاح',
    FromGroup: 'من مجموعة',
    ToGroup: 'إلى مجموعة',
    ChangedBy: 'غيّره',
    ChangedAt: 'تاريخ التغيير',
    FareMediaBatches: 'دفعات وسائل دفع الأجرة',
    AddFareMediaBatch: 'إضافة دفعة',
    AddNewFareMediaBatch: 'إضافة دفعة جديدة',
    EditFareMediaBatch: 'تعديل دفعة',
    FareMediaBatchInfo: 'معلومات الدفعة',
    FareMediaBatchCreatedSuccessfully: 'تم إنشاء الدفعة بنجاح',
    FareMediaBatchUpdatedSuccessfully: 'تم تحديث الدفعة بنجاح',
    SearchFareMediaBatchPlaceholder: 'البحث باسم الدفعة أو الملاحظات...',
    AreYouSureDeleteFareMediaBatch: 'هل أنت متأكد أنك تريد حذف هذه الدفعة؟',
    BatchLabel: 'اسم الدفعة',
    Notes: 'ملاحظات',
    CreatedBy: 'أنشئت بواسطة',
    UpdatedBy: 'تم التحديث بواسطة',
    FareMediaCount: 'عدد وسائل دفع الأجرة',
    IsDefault: 'المجموعة الافتراضية',
    FareProductOptions: 'خيارات منتج التعريفة',
    PurchasePrice: 'سعر الشراء',
    ContractDurationDays: 'مدة العقد (أيام)',
    MaxAmount: 'الحد الأقصى للإنفاق',
    MaxTrips: 'الحد الأقصى للرحلات',
    ConsumedTrips: 'الرحلات المستهلكة',
    ActivationTrigger: 'طريقة التفعيل',
    FirstUse: 'أول استخدام',
    FIRST_USE: 'أول استخدام',
    SpecificDate: 'تاريخ محدد',
    SPECIFIC_DATE: 'تاريخ محدد',
    IMMEDIATE: 'فوري',
    // v5 legacy kept for backward compat
    PrepaidPassOptions: 'خيارات منتج التعريفة',
    MaxUsageCount: 'الحد الأقصى للرحلات',
    ValidityDaysAfterActivation: 'مدة العقد (أيام)',
    PassName: 'اسم منتج التعريفة',
    PassCode: 'رمز منتج التعريفة',
    ConsumedAmount: 'المبلغ المستهلك',
    ContractStart: 'بداية العقد',
    ContractEnd: 'نهاية العقد',
    PurchasedAt: 'تاريخ الشراء',
    ActivatedAt: 'تاريخ التفعيل',
    TripsConsumed: 'المبلغ المستهلك',
    ExpiresAt: 'نهاية العقد',
    NoOffersFound: 'لا توجد نسخ منتجات تعريفة لهذه البطاقة.',
    FareProductNoUserHint: 'لا يمكنك استخدام شراء منتج التعريفة حتى يقوم المستخدم بإضافة وسيلة الدفع هذه في تطبيقه.',
    Offers: 'منتجات التعريفة',
    ConfirmNavigation: 'تأكيد الانتقال',
    UnsavedChangesWarning: 'تنبيه: التغييرات التي أجريتها في هذه الصفحة قد تضيع.',
    CancelFareProduct: 'إلغاء منتج التعريفة',
    CancelFareProductConfirm: 'هل أنت متأكد من إلغاء هذه النسخة؟ لا يمكن التراجع عن هذا الإجراء.',
    CancellationReason: 'سبب الإلغاء ',
    PleaseSelectBandAndDate: 'الرجاء اختيار خطة الخصم وتاريخ البدء.',
    CheckApplicableFares: "عرض الأسعار المطبقة",
    FailedToFetchApplicableFares: "تعذر جلب الأسعار المطبقة.",
    AxisAndZones: "المحور / النطاق",
    LowestChargeableFare: "أقل سعر يمكن تحصيله",
    HighestChargeableFare: "أعلى سعر يمكن تحصيله",
    NoBaseFareOnAxis: "لا يوجد سعر أساسي معرّف على هذا المحور",
    NoZonesOnAxis: "لا توجد نطاقات على هذا المحور — يطبق السعر الأساسي بالكامل",
    UnattributedFares: "أسعار غير مرتبطة بأي محور",
    DiscountExceedsFloor: "قيمة الخصم أكبر من أقل سعر يمكن تحصيله على المسارات المحددة",
    PriceBelowActiveDiscount: "هذا السعر أقل من خصم ثابت فعال على هذا المحور",
    MinimumAllowedPrice: "أقل قيمة مسموح بها",
    CouldNotVerifyDiscountUsage: "تعذر التحقق من الخصومات الفعالة على هذا المحور — سيتم الحفظ بدون هذا التحقق.",
    BaseFareLabel: "السعر الأساسي",
    EffectiveFare: "السعر الفعلي",
    FareValidFrom: "من",
    Zone: "نطاق",
    YourFixedDiscount: "قيمة الخصم الثابت",
    VerdictOk: "مناسب لجميع الأسعار الموضحة بالأسفل.",
    VerdictPartial: "يمكن حفظه، لكنه لا يناسب جميع المسارات.",
    VerdictBlockedBand: "تعذر الحفظ — قيمة الخصم أكبر من كل الأسعار في هذه المنظمة.",
    VerdictBlockedAssignment: "تعذر الحفظ — قيمة الخصم أكبر من أقل سعر على المسارات المحددة، مما يجعل تلك الرحلات مجانية.",
    AxesCheaperThanDiscount: "محاور سعرها أقل من قيمة الخصم",
    CheapestIs: "الأقل هو",
    AffectedHintBand: "سيتم رفض تعيين هذا الخصم على أي منها. وهي مميزة بالأسفل.",
    AffectedHintAssignment: "قم بإزالة تلك المسارات من هذا التعيين، أو بتقليل قيمة الخصم.",
    BelowDiscountMarker: "أقل من الخصم",
    DiscountExceedsMaxFare: "قيمة الخصم أكبر من أعلى سعر فعال",
    DiscountBandFaresHint: "كل سعر يمكن تحصيله في هذه المنظمة — السعر الأساسي لكل محور وتحته أسعار نطاقاته. الخصم الثابت الأعلى من أقلها يجعل تلك الرحلات مجانية.",
    AssignmentFaresHint: "كل سعر يمكن تحصيله على المسارات المحددة، الأسعار الأساسية وأسعار النطاقات معاً. أقل قيمة هي الحد الذي يطبقه هذا الحفظ بالضبط.",
    Yes: 'نعم',
    No: 'لا',
    DiscountBands: 'خطط الخصومات',
    AddNewDiscountBand: 'إضافة خطة خصم جديدة',
    EditDiscountBand: 'تعديل خطة الخصم',
    ArName: 'الاسم بالعربية',
    EnName: 'الاسم بالانجليزية',
    DiscountBandInfo: 'معلومات خطة الخصم',
    DiscountBandCreatedSuccessfully: 'تم إنشاء خطة الخصم بنجاح',
    DiscountBandUpdatedSuccessfully: 'تم تحديث خطة الخصم بنجاح',
    SearchDiscountBandPlaceholder: 'البحث بالكود أو الاسم...',
    AreYouSureDeleteDiscountBand: 'هل أنت متأكد أنك تريد حذف خطة الخصم هذه؟',
    DiscountValue: 'قيمة الخصم / العرض',
    Percentage: 'نسبة مئوية',
    Amount: 'مبلغ ثابت',
    RequiresDocuments: 'تتطلب مستندات',
    ValidFrom: 'ساري من (المنتج)',
    ValidTo: 'ساري إلى (المنتج)',
    AssignmentValidFrom: 'ساري من (التخصيص)',
    AssignmentValidTo: 'ساري إلى (التخصيص)',
    TimeFrom: 'من وقت',
    TimeTo: 'إلى وقت',
    AllDay: 'طوال اليوم',
    NoExpiry: 'بدون تاريخ انتهاء',
    AllDays: 'كل الأيام',
    AvailableDays: 'الأيام المتاحة',
    sunday: 'الأحد',
    monday: 'الاثنين',
    tuesday: 'الثلاثاء',
    wednesday: 'الأربعاء',
    thursday: 'الخميس',
    friday: 'الجمعة',
    saturday: 'السبت',
    DiscountPct: 'نسبة الخصم %',
    DiscountAmount: 'مبلغ الخصم',
    DiscountType: 'نوع الخصم',
    PassengerCategory: 'فئة الراكب',
    BasicInfo: 'المعلومات الأساسية',
    DiscountBand: 'خطة الخصم',
    PassengersGroup: 'مجموعة الركاب',
    passengers_group: 'مجموعة الركاب',
    DiscountCalculation: 'طريقة احتساب الخصم / العرض',
    Validity: 'معلومات الصلاحية',
    ApplyOnAllRoutes: 'تطبيق على جميع المسارات',
    IsActive: 'نشط',
    passengers_group_name: 'مجموعة الركاب',
    fare_media_batch_label: 'مجموعة الركاب (الدفعة)',
    SelectOrgFirst: 'اختر المؤسسة أولاً',
    GroupChangeWarning: 'إذا تم تغيير المجموعة، يجب إضافة الأهلية مرة أخرى وسوف يتم استبدال السابقة.',
    group_change_reason: 'سبب تغيير المجموعة',
    enter_reason: 'يرجى إدخال سبب تغيير المجموعة',
    Eligibility: 'الأهلية',
    GroupHistory: 'تاريخ المجموعة',
    from_group_name: 'من مجموعة',
    to_group_name: 'إلى مجموعة',
    AssociatedDiscountBandAssignments: 'التعيينات المرتبطة',
    AssociatedDiscountBands: 'خطط الخصم المرتبطة',
    AssociatedFareMediaEligibility: 'سجلات الأهلية المرتبطة',
    AssociatedTickets: 'التذاكر المرتبطة',
    changed_at: 'تاريخ التغيير',
    changed_by: 'تم التغيير بواسطة',
    doc_type_code: 'نوع المستند',
    DocumentTypes: 'انواع المستندات',
    DocumentType: 'نوع المستند',
    AddNewDocumentType: 'إضافة نوع مستند',
    EditDocumentType: 'تعديل نوع المستند',
    DocumentTypeInfo: 'معلومات نوع المستند',
    SearchDocumentTypePlaceholder: 'البحث في انواع المستندات...',
    AreYouSureDeleteDocumentType: 'هل أنت متأكد من حذف نوع المستند هذا؟',
    DocumentTypeCreatedSuccessfully: 'تم إنشاء نوع المستند بنجاح',
    DocumentTypeUpdatedSuccessfully: 'تم تحديث نوع المستند بنجاح',
    ValidationRules: 'قواعد التحقق',
    ValidationRulesOptional: 'قواعد التحقق (اختيارية)',
    ValidationRulesHint: 'حدد القواعد التي سيتم تطبيقها على حقل الملاحظات عند إضافة سجلات الأهلية لهذا النوع من المستندات.',
    InputType: 'نوع المدخل',
    NoRestriction: 'بدون قيود',
    NumericOnly: 'أرقام فقط',
    AlphaOnly: 'أحرف فقط',
    AlphanumericOnly: 'أحرف وأرقام (كلاهما)',
    MinLength: 'الحد الأدنى للطول',
    MaxLength: 'الحد الأقصى للطول',
    AllowSpecialChars: 'السماح بالأحرف الخاصة',
    SpecialCharsAllowed: 'الأحرف الخاصة المسموح بها',
    RemarksValidationRules: 'قواعد التحقق من الملاحظات',
    ClearValidationRules: 'مسح القواعد',
    ValidExampleShort: 'مثال',
    DocumentIdentifier: 'معرّف المستند',
    DocIdentifierShort: 'معرّف المستند',
    EnterDocumentIdentifier: 'أدخل معرّف المستند',
    IdentifierValidationRules: 'قواعد التحقق من المعرّف',
    optional: 'اختياري',
    AvailableDocumentTypes: 'المستندات المتاحة',
    SelectedDocumentTypes: 'المستندات المختارة',
    selected: 'مختار',
    RequiresDocumentsValidation: 'يرجى اختيار نوع مستند واحد على الأقل عند تفعيل خيار "تتطلب مستندات".',
    ActivationTriggerRequired: 'يجب تحديد طريقة التفعيل عند إدخال مدة العقد.',
    issued_at: 'تاريخ الإصدار',
    expires_at: 'تاريخ الانتهاء',
    verified_by: 'تم التحقق بواسطة',
    verified_at: 'تاريخ التحقق',
    remarks: 'ملاحظات',
    financialControl: 'التحكم المالى',
    digitalSignage: 'التوقيع الرقمى',
    helpDesk: 'الخدمة الفنية',
    editAdminInfo: 'تعديل بيانات الأدمن',
    resetPassword: 'إعادة تعيين كلمة السر',
    theNewPasswordMustHave: 'كلمة السر الجديدة يجب أن تحتوي على',
    sixOrMoreCharacters: 'أكثر من 6 أحرف',
    atLeastOneLetter: 'حرف واحد على الأقل',
    atLeastOneNumber: 'رقم واحد على الأقل',
    grantFullControl: 'إعطاء صلاحية التحكم الكامل',
    denyAllAccess: 'إزالة جميع الصلاحيات',
    editPermissions: 'تعديل الصلاحيات',
    noAccess: 'لا يوجد صلاحيات',
    fullAccess: 'التحكم الكامل',
    readOnly: 'قراءة فقط',
    adminPermissions: 'صلاحيات الأدمن',
    admin: 'ادمن',
    successUpdatePermissions: 'تم تحديث الصلاحيات بنجاح',
    successGrantFullControl: 'تم إعطاء صلاحية التحكم الكامل بنجاح',
    successDenyAllAccess: 'تم إزالة جميع الصلاحيات بنجاح',
    superAdmin: 'مدير عام',
    tripSales: 'أموال الرحلات',
    addTripSale: 'إضافة أموال الرحلات',
    ticketSerial: 'رقم التذكرة',
    stop: 'التوقف',
    vehicle: 'المركبة',
    timeAndDate: 'الوقت والتاريخ',
    createdAtDate: 'تاريخ الإنشاء',
    baseAmount: 'المبلغ الأساسي',
    trip: 'الرحلة',
    fromDate: 'من تاريخ',
    toDate: 'إلى تاريخ',
    stops: 'المحطات',
    price: 'السعر',
    successdeleteaxis: 'تم حذف المحور بنجاح',
    successAddAxis: 'تم إضافة المحور بنجاح',
    successEditAxis: 'تم تحديث المحور بنجاح',
    addAxis: 'إضافة محور',
    editAxis: 'تعديل محور',
    axes: 'المحاور',
    addStop: 'إضافة محطة',
    selectAStop: 'إختر محطة',
    dragRowsToReorder: 'قم بسحب الصفوف لإعادة ترتيبها',
    axis: 'محور',
    priceEGP: 'السعر (جنيه)',
    _stops: 'محطة',
    priceNumberValidation: 'السعر لابد أن يكون أرقام فقط',
    nextPage: 'الصفحة التالية',
    previousPage: 'الصفحة السابقة',
    nogroup: 'لا توجد مجموعات',
    createAdmin: 'إنشاء أدمن',
    passwordRulesNotMatchMessage:
      'كلمة السر يجب أن تحتوي على حرف واحد على الأقل وأكثر من 6 أحرف',
    plateNumber: 'رقم اللوحة',
    addVehicle: 'إضافة المركبة',
    editVehicle: 'تعديل المركبة',
    vehicleInfo: 'معلومات المركبة',
    type: 'النوع',
    vehicles: 'المركبات',
    backToVehiclesList: 'عودة لقائمة المركبات',
    color: 'اللون',
    modelYear: 'سنة الموديل',
    successEditVehicle: 'تم تحديث المركبة بنجاح',
    successAddVehicle: 'تم إضافة المركبة بنجاح',
    successdeletevehicle: 'تم حذف المركبة بنجاح',
    vehicleType: 'نوع المركبة',
    vehicleTypes: 'أنواع المركبات',
    searchByVehicleCodeOrPlateNumber: 'بحث برقم اللوحة أو رقم المركبة',
    vehicleCode: 'رقم المركبة',
    vehicleModelYear: 'سنة موديل المركبة',
    noOrganizationFound: 'لا توجد شركات',
    devices: 'الأجهزة',
    ip: 'الاي بي',
    serial: 'الرقم التسلسلي',
    deviceInfo: 'معلومات الجهاز',
    device: 'الجهاز',
    backToDevicesList: 'عودة لقائمة الأجهزة',
    addDevice: 'إضافة جهاز',
    editDevice: 'تعديل جهاز',
    createDevice: 'إنشاء جهاز',
    successEditDevice: 'تم تحديث الجهاز بنجاح',
    successAddDevice: 'تم إضافة الجهاز بنجاح',
    successdeletedevice: 'تم حذف الجهاز بنجاح',
    deviceType: 'نوع الجهاز',
    deviceTypes: 'أنواع الاجهزة',
    searchByDeviceCodeOrSerial: 'بحث برقم الجهاز أو الرقم التسلسلي',
    devicesManagement: 'إدارة الأجهزة',
    unassigned: 'غير معين',
    vehiclesManagement: 'إدارة المركبات',
    successdeleteroute: 'تم حذف المسار بنجاح',
    adminManagement: 'إدارة الأدمن',
    addGroup: 'إضافة مجموعة',
    successAddGroup: 'تم إضافة المجموعة بنجاح',
    successEditGroup: 'تم تحديث المجموعة بنجاح',
    editGroup: 'تعديل مجموعة',
    successdeletegroup: 'تم حذف المجموعة بنجاح',
    backToGroupsList: 'عودة لقائمة المجموعات',
    groupInfo: 'معلومات المجموعة',
    minLengthOneValidation: 'هذا الحقل يجب ان يحتوى على عنصر واحد على الاقل',
    codeNumberValidation: 'رقم المركبة لابد أن يكون أرقام فقط',
    codeLengthValidation: 'رقم المركبة لابد أن يكون أرقام فقط',
    editStop: 'تعديل محطة',
    longitude: 'خط الطول',
    latitude: 'خط العرض',
    lonNumberValidation: 'خط الطول لابد أن يكون أرقام فقط',
    latNumberValidation: 'خط العرض لابد أن يكون أرقام فقط',
    backToStationsList: 'عودة لقائمة المحطات',
    addStation: 'إضافة محطة',
    editStation: 'تعديل محطة',
    stationInfo: 'معلومات المحطة',
    stationCode: 'كود المحطة',
    stationCodeAlphanumeric:
      'كود المحطة يجب أن يبدأ بحروف وينتهي بأرقام (مثال: ABC123)',
    stationCodeUpdateFailed: 'فشل تحديث كود المحطة',
    stopCode: 'كود الموقف',
    stopCodeAlphanumeric:
      'كود الموقف يجب أن يبدأ بحروف وينتهي بأرقام (مثال: WAYZ123)',
    stopCodeUpdateFailed: 'فشل تحديث كود الموقف',
    importStations: 'استيراد المحطات',
    importStops: 'استيراد المواقف',
    successUploadStations: 'تم رفع ملف المحطات بنجاح',
    successUploadStops: 'تم رفع ملف المواقف بنجاح',
    stations: 'المحطات',
    assignToGroup: 'تعيين إلى مجموعة',
    unAssignFromGroups: 'إلغاء تعيين المجموعات',
    confirmunAssignFromGroupsMessage:
      'هل أنت متأكد من إلغاء تعيين المجموعات من',
    station: 'محطة',
    successEditStation: 'تم تحديث المحطة بنجاح',
    successAddStation: 'تم إضافة المحطة بنجاح',
    successdeletestation: 'تم حذف المحطة بنجاح',
    successAddStop: 'تم إضافة المحطة بنجاح',
    successEditStop: 'تم تحديث المحطة بنجاح',
    successdeletestop: 'تم حذف المحطة بنجاح',
    assigned: 'معين',
    assignDeviceToVehicle: 'تعيين الجهاز إلى المركبة',
    changeDevice_serial: 'تغيير الجهاز {serial}',
    fromVehicle_Code_to: 'من المركبة رقم {from} إلى',
    assignDevice_serial: 'تعيين الجهاز {serial}',
    toVehicleCode: 'إلى المركبة رقم',
    assignedTo_code: 'معين إلى {code}',
    assignDeviceToVehicleMsg:
      'هل انت متأكد من تغيير الجهاز {serial} من كود المركبة {currentVehicleCode} إلى {code}',
    stationList: 'قائمة المحطات',
    vehicleClass: 'فئة المركبة',
    vehicleClasses: 'فئات المركبات',
    addVehicleClass: 'إضافة فئة مركبة',
    editVehicleClass: 'تعديل فئة المركبة',
    vehicleClassInfo: 'معلومات فئة المركبة',
    successAddVehicleClass: 'تم إضافة فئة المركبة بنجاح',
    successEditVehicleClass: 'تم تحديث فئة المركبة بنجاح',
    successdeletevehicleClass: 'تم حذف فئة المركبة بنجاح',
    noVehicleClassFound: 'لا يوجد فئات مركبات',
    noVehicleClassesFound: 'لا يوجد فئات مركبات',
    backToVehicleClassesList: 'عودة لقائمة فئات المركبات',
    avgSpeedNumberValidation: 'السرعة المتوسطة لابد أن يكون أرقام فقط',
    averageSpeed: 'سرعة المتوسطة',
    addVehicleType: 'إضافة نوع مركبة',
    editVehicleType: 'تعديل نوع المركبة',
    vehicleTypeInfo: 'معلومات نوع المركبة',
    successAddVehicleType: 'تم إضافة نوع المركبة بنجاح',
    successEditVehicleType: 'تم تحديث نوع المركبة بنجاح',
    successdeletevehicleType: 'تم حذف نوع المركبة بنجاح',
    noVehicleTypeFound: 'لا يوجد نوع مركبات',
    noVehicleTypesFound: 'لا يوجد نوع مركبات',
    backToVehicleTypesList: 'عودة لقائمة نوع المركبات',
    capacity: 'السعة',
    capacityValidation: 'السعة لابد أن تكون أرقام فقط',
    searchByVehicleCode: 'بحث بكود المركبة',
    searchByCode: 'بحث بالكود',
    searchByVehicleCodeOrSerial: 'بحث بكود المركبة أو رقم الجهاز',
    deviceIdentifier: 'معرف الجهاز',
    ipIsInvalid: 'عنوان IP غير صحيح',
    changeDeviceOrgMsg:
      'إذا قمت بتغيير الشركة، فسوف يتم إزالة السيارة الحالية من الجهاز',
    changeVehicleOrgMsg:
      'إذا قمت بتغيير الشركة، فسوف يتم إزالة الجهاز من السيارة الحالية',
    cash: 'كاش',
    card: 'بطاقة',
    cashPriceEGP: 'سعر الكاش (جنيه)',
    cardPriceEGP: 'سعر البطاقة (جنيه)',
    successChangePassword: 'تم تعديل كلمة السر بنجاح!',
    importMissingField: 'الحقل "{fieldName}" مفقود',
    groupNotFound: 'المجموعة "{groupName}" غير موجودة لهذه الشركة',
    importErrorAtRecord: 'خطأ في السجل رقم {rowNum}: {error}',
    importRemoteErrorAtRecord: 'خطأ في {rowNum}: {error}',
    importFileTooBig3MB: 'حجم الملف أكبر من 3 ميجابايت',
    vehicleTypeNotFound: 'نوع المركبة غير موجود',
    successImportMessage: 'تم تحميل {count} سجلات بنجاح',
    app_title: "مواصلات مصر",
    language: "اللغة",
    welcome_message: "اهلا بكم",
    days_since_release: "لقد مرت {{number_of_days}} أيام على إصدار هذا الفيديو",
    NoDateAvailable: "لا يوجد بيانات متاحة",
    LoginAgain: "قم بإعادة تسجيل الدخول ",
    From: "من",
    WelcomeTo: "مرحبا بك ",
    PleaseLoginToAccessYourAccount: "قم بتسجيل الدخول للوصول لحسابك",
    AxisInfo: "بيانات المحور",
    StopsInfo: "بيانات المحطات",
    CashPrice: "سعر النقدي",
    CardPrice: "سعر البطاقة",
    BackToHome: "العودة ",
    MakeSureYouHaveOpPermission: "تأكد انك تمتلك بعض  اللأذونات الضرورية في الأنظمة الداخلية للعمليات ",
    YouAreNotAllowedToDoThis: "غير مسموح لك بهذة العملية",
    YouHaveNoAccess: "لا تمتلك الأذونات اللازمة للوصول",
    ObjWSIdNotFound: "هناك مشكلة في الحصول علي اسم الموديول , قد يرجع هذا لحدوث خطأ في استخدام البيانات المتاحة",
    ThisActionNeedToGrantControlForRoutesOfTheOrganisationFirst: "هذة الخطوة تتطلب  اعطاء الصلاحيات لمسارات الشركة اولا",
    ThisActionNeedToDenyControlForFaresOfTheOrganisationFirst: "هذة الخطوة تتطلب  إزالة الصلاحيات لمنتجات تسعير الشركة اولا",
    Grant: "إعطاء",
    Deny: "إذالة",
    Atten: "تنبية",
    CantGetImportantUsedDataFromGroupsApi: " لم نستطيع جلب بيانات المجموعات , قم بالرجوع و إعادة المحاولة",
    NoMessageFound: "جاري التحميل ...",
    someThingWentWrongError: "هناك خطأ ما , قم بالرجوع و إعادة المحاولة",
    noteFaresSybPermissonsChangedToBeLikeRoutesPermissions: "تنبية : أي تغيير في صلاحيات المسارات قد يؤثر علي صلاحيات التسعير",
    errorWhenApplyingPermissionsInGrantFaresReadonlyAccessPleaseTryAgain: "خطأ في إعطاء صلاحيات المشاهدة فقط في التسعير , قم بإعطائها يدويا",
    errorWhenApplyingPermissionsInGrantFaresFullControlAccessPleaseTryAgain: " خطأ في إعطاء  كامل الصلاحيات   في التسعير , قم بإعطائها يدويا",
    errorWhenApplyingPermissionsInRoutesPleaseTryAgain: " خطأ في إعطاء صلاحيات المسارات , قم بإعطائها يدويا",
    AnErrorHappend: "هناك خطأ ما حدث ",
    SuccessOperationHappend: "تمت العملية بنجاح",
    yourAvailableBalance: "الرصيد المتاح",
    StopsNumber: "عدد المحطات",
    clearAll2: "رجوع ",
    zones: "النطاقات",
    zone: "نطاق",
    AddZone: "إضافة نطاق",
    NameCode: " الأسم ( الكود )",
    BaseFare: "   السعر  اللأساسي ( نقدي / بطاقة )",
    CuSym: " ج.م ",
    ZoneInfo: "معلومات النطاق",
    ThisStopIsIn: "هذة المحطة في نطاق  ",
    // Zoning Routes > axis: add / edit / delete zone toasts
    // (delete + edit reuse the shared DeletedSuccessfully / UpdatedSuccessfully keys)
    AddedSuccessfully: "تمت الإضافة بنجاح",
    EmptyFields: "حقول فارغة",
    PriceEnteredIsVeryHigh: "السعر المُدخل كبير جداً",
    NameEnteredIsVeryHigh: "الاسم المُدخل طويل جداً",
    ZoneActionFailedRetry: "عذراً , {err} , برجاء المحاولة لاحقاً أو إعادة تحميل الصفحة , كود : {code}",
    ZoneActionFailed: "عذراً , {err} , كود : {code}",
    loginErr1: " يجب أن تدخل أسم المستخدم و كلمة السر",
    loginErr2: "خطأ في أسم المستخدم او كلمة السر",
    loginSuccess: "تم تسجيل الدخول بنجاح",
    RemoveMarker: "حذف",
    WaitMessage: "انتظر حتي يتم تحميل البيانات , إذا استغرق الأمر الكثير من الوقت قم بإعادة تحميل الصفحة",
    SearchByFareMediaSerial: "أدخل الرقم المسلسل لوسيلة دفع التعريفة",
    transID: "رقم العملية",
    ticketPrice: 'المبلغ الأساسي',
    amountAfterDiscount: 'المبلغ بعد الخصم',
    discountBandCode: 'كود الخصم',
    isOffline: 'أوفلاين',
    online: 'أونلاين',
    offline: 'أوفلاين',
    assignmentLink: 'التخصيص',
    assignmentLinkBtn: 'عرض التخصيص',
    SelectGroupFirst: 'الرجاء اختيار مجموعة الفئات أولاً',
    discountTypeCode: 'نوع الخصم',
    discountBandPctAmount: 'نسبة/قيمة الخصم',
    internal_id: 'المعرف الداخلي',
    ticketDate: 'تاريخ التذكرة',
    driverName: "أسم السائق",
    driverUserName: " رقم السائق",
    axisName: "أسم المحور",
    deviceSerialNumber: "رقم الجهاز التسلسلي",
    endDate: "إلي",
    startDate: "من",
    transactionsNumber: "مجموع العدد :",
    transactionsTotalAmount: "مجموع النقديات :",
    ResetFilter: "حذف التصفية",
    NoFareMediaExist: "لا يوجد بيانات متاحة لهذا الرقم",
    serial_num: "الرقم المسلسل",
    uid: "الرقم المميز",
    parent_wallet_balance: "الرصيد",
    fare_media_type_name: "النوع",
    is_blacklisted: "محظورة",
    issuer_name: "المصدر",
    account_id: "رقم الحساب",
    init_balance: "الرصيد اللأولي",
    org_name: "الشركة",
    created_at: "تاريخ الصنع",
    updated_at: "أخر تعديل",
    tickets: "التذاكر",
    charging: "الشحن",
    deviceLimitErrorMsg: "عذرا , لقد وصلت إلى الحد الاقصي",
    user_name: "اسم المالك",
    user_phone: "رقم هاتف المالك",
    user_email: "بريد الكتروني المالك",
    expiration_date: "تاريخ اللأنتهاء",
    AFCReports: "تقارير التحصيل",
    CardsReports: "تقارير كروت",
    OperationsReports: "تقارير التشغيل",
    CardsManagement: "إدارة الكروت",
    Merchants: "البائعين",
    MerchantPOS: "أجهزة شحن البائعين",
    ChargingTransactions: "عمليات الشحن",
    AddNewMerchant: "إضافة بائع جديد",
    AddMerchant: "إضافة بائع ",
    MerchantNameEn: "إسم البائع - إنجليزي",
    MerchantNameAr: "إسم البائع - عربي",
    MerchantStatus: "الحالة",
    Adding: "جاري الاضافة ...",
    EditMerchant: "تعديل بيانات البائع",
    Updating: "جاري التعديل ...",
    AddNewMerchantPOS: "إضافة جهاز شحن جديد للبائع",
    AddMerchantPOS: "إضافة جهاز شحن ",
    EditMerchantPOS: "تعديل جهاز شحن",
    UserLimit: "الحد المسموح",
    SelectMerchant: "اختر بائع ",
    POSName: "اسم الجهاز",
    POSCount: "عدد الاجهزة",
    Of: "من",
    MerchantInfo: "معلومات البائع",
    BackToMerchants: "الرجوع للبائعين",
    MerchantName: "إسم البائع ",
    MerchantPOSName: "الاسم",
    SearchByPOSName: "بحث باسم الجهاز",
    MerchantPOSInfo: "معلومات جهاز الشحن",
    BackToMerchantPOS: "الرجوع لاجهزة شحن البائعين",
    POSStatus: "حالة جهاز الشحن",
    MerStatus: "حالة البائع",
    FareMediaSerial: "الرقم التسلسلي ",
    TransactionNumber: "رقم العملية",
    FareMediaAmount: "رصيد وسيلة الدفع",
    SearchByTransactionNumber: "البحث برقم العملية",
    POSSerialNumber: "رقم جهاز الشحن التسلسلي",
    FareMedia: "وسائل دفع التعريفة",
    AddFareMedia: "اضافة",
    AddNewFareMedia: "اضافة وسيلة جديدة لدفع التعريفة",
    SellingPrice: "سعر البيع",
    DownloadTemplate: "تنزيل القالب ",
    UploadFile: "رفع الملف",
    Uploading: "جاري الرفع ...",
    deviceSN: "رقم الجهاز التسلسلي",
    NewBalance: "الرصيد الجديد",
    SN: "الرقم التسلسلي",
    Vat: "القيمة المضافة",
    TotalFees: "الضريبة",
    PaidAmount: "المبلغ المدفوع",
    SearchBySerial: "البحث بالرقم التسلسلي",
    selling_price: "سعر البيع",
    Selling: "البيع",
    sold_date: "تاريخ البيع",
    ar_fare_media_type_name: " النوع - عربي ",
    ar_issuer_name: " المصدر - عربي ",
    ar_org_name: " الشركة - عربي ",
    Reports: "التقارير",
    EditFareMedia: "تعديل وسيلة دفع التعريفة",
    Blacklisted_note: "السبب ",
    is_sold: "مباع",
    issuing_date: "تاريخ الاصدار",
    distribution_date: " تاريخ التوزيع",
    total_charging_amount: "مجموع عمليات الشحن",
    total_ticketing_amount: "مجموع عمليات قطع التذاكر",
    calculated_balance: "الرصيد اعتمادا علي عمليات الشحن و النذاكر",
    addToFareMediaBalance: "اضافة الي رصيد وسيلة دفع الاجرة",
    removeFareMediaBalance: "الخصم من رصيد وسيلة دفع الاجرة",
    BalanceIsCorrect: "الرصيد صحيح",
    BalanceNotes: "ملاحظات علي الرصيد",
    FareMediaInfo: "معلومات وسيلة دفع الاجرة",
    currency: " ج.م ",
    loading: "جاري التحميل ...",
    Logs: "السجلات",
    request: "الطلب",
    response: "الرد",
    SelectCommission_type: "اختر نوع العمولة",
    commissionType: "نوع العمولة",
    com_prov: "عمولة مقدم الخدمة ",
    com_ret: "عمولة التجزئة ",
    flat_fee: "رسوم ثابتة ",
    Commissions: "العمولات",
    unCalcYet: "لم يتم حسابها بعد",
    multi_org: "شركات متعددة",
    Select_Organization: "اختر الشركة",
    Not_Allowed_to_edit: "يُسمح فقط بإلغاء حظر البطاقات المحظورة من قبل المشرفين",
    allowed_multi_org: "(يسمح بتعدد العمولات)",
    not_allowed_multi_org: "(لا يسمح بتعدد العمولات)",
    both: 'كلاهما',
    transactionAmount: 'المبلغ',
    cardSerial: 'رقم البطاقة',
    merchantRef: 'رقم البائع',
    ticket: 'التذكرة',
    description: "الوصف",
    channel: "قناة الدفع",
    debit: "الخصم",
    credit: "الشحن",
    balance: "الرصيد",
    chargingOperation: "عملية شحن",
    ticketingOperation: "عملية تذكرة",
    reversalOperation: "عملية عكس معاملة غير ناجحة",
    initBalanceOperation: "عملية الحصول علي الرصيد الافتتاحي",
    feesDeductedOnCharging: "رسوم عملية الشحن",
    vatDeductedOnCharging: "ض.ق.م عملية الشحن ",
    transferFromWalletOperation: "تحويل من المحفظة",
    transferToWalletOperation: "تحويل إلى المحفظة",
    migrationOperation: "ترحيل",
    totalAmount: 'الرصيد الحالي',
    totalCredits: 'إجمالي الشحنات / الأضافات',
    totalDebits: 'إجمالي الخصومات / التناقصات',
    accountStatementTotalsLabel: 'الإجمالي [جنيه]:',
    displayedTotalAmount: 'إجمالي المبلغ المعروض',
    displayedTotalCredits: 'إجمالي الشحنات / الأضافات المعروضة',
    displayedTotalDebits: 'إجمالي الخصومات / التناقصات المعروضة',
    TotalDisplayed: "إجمالي المعروض",
    AccountStatement: "كشف الحساب ",
    NoOfTransactions: "عدد العمليات",
    Settlements: "التسويات",
    SettlementTransactions: " تسوية الشركات",
    // Settlement Transactions
    settlement_Date: "التاريخ",
    settlement_Sender: "المرسل",
    settlement_Beneficiary: "المستفيد",
    settlement_Type: "النوع",
    settlement_Period: "الفترة",
    settlement_Amount: "المبلغ",
    settlement_Status: "الحالة",
    settlement_Actions: "الإجراءات",
    settlement_All: "الكل",
    settlement_Draft: "مسودة",
    settlement_Confirmed: "مؤكد",
    settlement_Cleared: "تم الإنهاء",
    settlement_Reversed: "عكسي",
    settlement_ContinueConfirm: "متابعة وتأكيد",
    settlement_Continue: "متابعة",
    settlement_Clear: "إنهاء",
    settlement_ClearSettlement: "إنهاء التسوية",
    settlement_Reverse: "عكس",
    settlement_ReverseSettlement: "عكس التسوية",
    settlement_SettlementIsCleared: "تم إنهاء التسوية - لا يمكن عكسها",
    settlement_SearchPlaceholder: "البحث عن المرسل/المستفيد/النوع",
    settlement_Refresh: "تحديث",
    settlement_NewSettlement: "تسوية جديدة",
    settlement_FailedToLoad: "فشل تحميل التسويات",
    settlement_MarkAsCleared: "وضع علامة كإنهاء",
    settlement_ACHReferenceNo: "رقم مرجع ACH",
    settlement_PleaseEnterACHRef: "الرجاء إدخال رقم مرجع ACH",
    settlement_EnterBankRefNumber: "أدخل رقم المرجع البنكي",
    settlement_Description: "الوصف",
    settlement_PleaseEnterDescription: "الرجاء إدخال وصف",
    settlement_NoDescriptionEntered: "لم يتم إدخال وصف",
    settlement_DescriptionPlaceholder: "مثال: تم تحويل تسوية الربع الأول",
    settlement_TransferDate: "تاريخ التحويل",
    settlement_PleaseSelectTransferDate: "الرجاء تحديد تاريخ التحويل",
    settlement_TransferDateCannotBeFuture: "لا يمكن أن يكون تاريخ التحويل في المستقبل",
    settlement_ToDateCannotBeFuture: "لا يمكن أن يكون تاريخ الانتهاء في المستقبل",
    settlement_SelectDate: "اختر التاريخ",
    settlement_SettlementConfirmed: "تم تأكيد التسوية",
    settlement_MarkedAsCleared: "تم وضع علامة على التسوية كإنهاء",
    settlement_FailedToClear: "فشل في إنهاء التسوية",
    settlement_ReversalReason: "سبب العكس",
    settlement_PleaseEnterReversalReason: "الرجاء إدخال سبب العكس",
    settlement_EnterReasonForReversal: "أدخل سبب العكس",
    settlement_ReversedSuccessfully: "تم عكس التسوية بنجاح",
    settlement_FailedToReverse: "فشل في عكس التسوية",
    settlement_ReversedAt: "تاريخ العكس",
    settlement_ReversedBy: "تم العكس بواسطة",
    settlement_ReversalInformation: "معلومات العكس",
    settlement_CreatedAt: "تاريخ الإنشاء",
    settlement_AddSettlementTransaction: "إضافة معاملة تسوية",
    settlement_PartiesPeriod: "الأطراف والفترة",
    settlement_SelectSenderBeneficiaryPeriod: "اختر المرسل والمستفيد وفترة التسوية",
    settlement_TransactionSummary: "ملخص المعاملات",
    settlement_ReviewTransactionsSelectChannels: "مراجعة المعاملات واختيار القنوات",
    settlement_FinancialAccounts: "الحسابات المالية",
    settlement_MapAccountsForERP: "تعيين الحسابات لاقتراحات قيود ERP",
    settlement_BankTransfer: "التحويل البنكي",
    settlement_SelectBankAccountsAddNotes: "اختر الحسابات البنكية وأضف ملاحظات",
    settlement_Review: "مراجعة",
    settlement_ReviewConfirmSettlement: "مراجعة وتأكيد التسوية",
    settlement_Back: "رجوع",
    settlement_SaveAsDraft: "حفظ كمسودة",
    settlement_Next: "التالي",
    settlement_ReviewSettlement: "مراجعة التسوية",
    settlement_ConfirmSettlement: "تأكيد التسوية",
    settlement_SavingDraft: "جاري حفظ المسودة...",
    settlement_DraftSaved: "تم حفظ المسودة",
    settlement_FailedToSaveDraft: "فشل في حفظ المسودة",
    settlement_SaveDraftStep1Only: "حفظ المسودة (الخطوة 1 فقط)",
    settlement_OnlyStep1WillBeSaved: "سيتم حفظ الخطوة 1 (الأطراف والفترة) فقط في المسودة.",
    settlement_DataFromOtherStepsWillNotBeSaved: "لن يتم حفظ البيانات من الخطوات الأخرى (ملخص المعاملات، الحسابات المالية، التحويل البنكي).",
    settlement_DoYouWantToContinue: "هل تريد المتابعة؟",
    settlement_SaveStep1Only: "حفظ الخطوة 1 فقط",
    settlement_DraftSavedStep1Only: "تم حفظ المسودة (الخطوة 1 فقط)",
    settlement_SettlementSavedAsDraft: "تم حفظ التسوية كمسودة",
    settlement_YouAreAboutToCreate: "أنت على وشك إنشاء تسوية مؤكدة:",
    settlement_ThisActionCannotBeEdited: "لا يمكن التراجع عن  هذا الإجراء بعد التأكيد.",
    settlement_ConfirmAndClose: "تأكيد وإغلاق",
    settlement_BankAccountsMustBeSelected: "يجب تحديد الحسابات البنكية. يرجى العودة إلى الخطوة 4 وتحديد الحسابات البنكية.",
    settlement_CreatedAndConfirmedSuccessfully: "تم إنشاء وتأكيد التسوية بنجاح",
    settlement_FailedToCreate: "فشل في إنشاء التسوية",
    settlement_PostConfirmationViewSettlement: "ما بعد التأكيد: عرض التسوية",
    settlement_PrintSettlement: "طباعة التسوية",
    settlement_SettlementHasBeenCleared: "✓ تمت إنهاء التسوية ولا يمكن تعديلها",
    settlement_Close: "إغلاق",
    close: "إغلاق",
    settlement_PleaseAllowPopups: "يرجى السماح بالنوافذ المنبثقة لعرض معاينة PDF",
    settlement_PDFPreviewOpened: "تم فتح معاينة PDF في علامة تبويب جديدة",
    settlement_FailedToOpenPDFPreview: "فشل في فتح معاينة PDF",
    settlement_SettlementDetails: "تفاصيل التسوية",
    settlement_PeriodLabel: "الفترة",
    settlement_From: "من",
    settlement_To: "إلى",
    settlement_SenderOurCompany: "المرسل (شركتنا)",
    settlement_Organisation: "الشركة",
    settlement_Bank: "البنك",
    settlement_BankAccount: "الحساب البنكي",
    settlement_SenderNotSelected: "لم يتم اختيار المرسل",
    settlement_BeneficiaryPTO: "المستفيد (PTO)",
    settlement_BeneficiaryNotSelected: "لم يتم اختيار المستفيد",
    settlement_AmountCurrency: "المبلغ والعملة",
    settlement_Currency: "العملة",
    settlement_SuggestedERPJournalEntrySender: "اقتراح قيد يومية ERP (المرسل)",
    settlement_Account: "الحساب",
    settlement_Debit: "مدين",
    settlement_Credit: "دائن",
    settlement_Total: "الإجمالي",
    settlement_SuggestedERPJournalEntryBeneficiary: "اقتراح قيد يومية ERP (المستفيد)",
    settlement_BankTransferDetails: "تفاصيل التحويل البنكي",
    settlement_ACHReference: "مرجع ACH",
    settlement_BankTransferNotes: "ملاحظات التحويل البنكي",
    settlement_NoAdditionalNotes: "لا توجد ملاحظات إضافية",
    settlement_SenderBankNotSelected: "لم يتم اختيار بنك المرسل",
    settlement_BeneficiaryBankNotSelected: "لم يتم اختيار بنك المستفيد",
    settlement_SenderAccountNotSelected: "لم يتم اختيار حساب المرسل",
    settlement_BeneficiaryAccountNotSelected: "لم يتم اختيار حساب المستفيد",
    settlement_Channel: "القناة",
    settlement_Transactions: "المعاملات",
    settlement_GrossAmount: "المبلغ الإجمالي",
    settlement_Fees: "الرسوم",
    settlement_VAT: "ضريبة القيمة المضافة",
    settlement_AmountToSettle: "المبلغ المطلوب تسويته",
    settlement_OurBank: "بنكنا؟",
    settlement_Include: "تضمين؟",
    settlement_FailedToLoadInitialData: "فشل في تحميل البيانات الأولية",
    settlement_SettlementType: "نوع التسوية",
    settlement_SelectSettlementType: "اختر نوع التسوية",
    settlement_PleaseSelectSettlementType: "يرجى اختيار نوع التسوية",
    settlement_SenderOrganisation: "شركة المرسل",
    settlement_SelectSenderOrganisation: "اختر شركة المرسل",
    settlement_PleaseSelectSenderOrganisation: "يرجى اختيار شركة المرسل",
    settlement_BeneficiaryOrganisation: "شركة المستفيد",
    settlement_SelectBeneficiaryOrganisation: "اختر شركة المستفيد",
    settlement_PleaseSelectBeneficiaryOrganisation: "يرجى اختيار شركة المستفيد",
    settlement_FromDate: "من تاريخ",
    settlement_PleaseSelectFromDate: "يرجى تحديد من تاريخ",
    settlement_ToDate: "إلى تاريخ",
    settlement_PleaseSelectToDate: "يرجى تحديد إلى تاريخ",
    settlement_Notes: "ملاحظات",
    settlement_AddNotesOptional: "إضافة ملاحظات (اختياري)",
    settlement_FailedToLoadTransactionData: "فشل في تحميل بيانات المعاملات",
    settlement_LoadingTransactions: "جاري تحميل المعاملات...",
    settlement_NoDataAvailable: "لا توجد بيانات متاحة",
    settlement_NoTransactionsFound: "لم يتم العثور على معاملات للفترة المحددة",
    settlement_SelectAtLeastOneChannel: "يرجى تحديد قناة واحدة على الأقل لتضمينها",
    settlement_FailedToLoadAccounts: "فشل في تحميل الحسابات",
    settlement_LoadingAccounts: "جاري تحميل الحسابات...",
    settlement_SenderAccounts: "حسابات المرسل",
    settlement_DebitAccount: "حساب مدين",
    settlement_SelectDebitAccount: "اختر حساب مدين",
    settlement_PleaseSelectDebitAccount: "يرجى اختيار حساب مدين",
    settlement_CreditAccount: "حساب دائن",
    settlement_SelectCreditAccount: "اختر حساب دائن",
    settlement_PleaseSelectCreditAccount: "يرجى اختيار حساب دائن",
    settlement_IncomeAccount: "حساب الدخل",
    settlement_SelectIncomeAccount: "اختر حساب الدخل",
    settlement_PleaseSelectIncomeAccount: "يرجى اختيار حساب الدخل",
    settlement_TaxLiabilityAccount: "حساب الالتزامات الضريبية",
    settlement_SelectTaxLiabilityAccount: "اختر حساب الالتزامات الضريبية",
    settlement_PleaseSelectTaxLiabilityAccount: "يرجى اختيار حساب الالتزامات الضريبية",
    settlement_BeneficiaryAccounts: "حسابات المستفيد",
    settlement_ExpenseAccount: "حساب المصروفات",
    settlement_SelectExpenseAccount: "اختر حساب المصروفات",
    settlement_PleaseSelectExpenseAccount: "يرجى اختيار حساب المصروفات",
    settlement_TaxAssetAccount: "حساب الأصول الضريبية",
    settlement_SelectTaxAssetAccount: "اختر حساب الأصول الضريبية",
    settlement_PleaseSelectTaxAssetAccount: "يرجى اختيار حساب الأصول الضريبية",
    settlement_FailedToLoadBanks: "فشل في تحميل البنوك",
    settlement_LoadingBanks: "جاري تحميل البنوك...",
    settlement_SenderBank: "بنك المرسل",
    settlement_SelectSenderBank: "اختر بنك المرسل",
    settlement_PleaseSelectSenderBank: "يرجى اختيار بنك المرسل",
    settlement_BeneficiaryBank: "بنك المستفيد",
    settlement_SelectBeneficiaryBank: "اختر بنك المستفيد",
    settlement_PleaseSelectBeneficiaryBank: "يرجى اختيار بنك المستفيد",
    settlement_SettlementSummary: "ملخص التسوية",
    settlement_NetAmountToSettle: "صافي المبلغ المطلوب تسويته",
    settlement_TotalFees: "إجمالي الرسوم",
    settlement_TotalVAT: "إجمالي ضريبة القيمة المضافة",
    settlement_SelectedChannels: "القنوات المختارة",
    settlement_EGP: " ج.م",
    settlement_EGPEgyptianPound: "ج.م  - EGP",
    settlement_AutoCalculatedBasedOnPrevious: "محسوبة تلقائياً بناءً على التسويات السابقة",
    settlement_PleaseSelectEndDate: "يرجى تحديد تاريخ الانتهاء",
    settlement_UnsettledDuesAccountAsset: "حساب المستحقات غير المسددة (أصل)",
    settlement_PleaseSelectUnsettledDuesAccount: "يرجى اختيار حساب المستحقات غير المسددة",
    settlement_PTOReceivableMidar: "مثال: 'مستحقات PTO - ميدار'، #11200",
    settlement_BankAccountAsset: "الحساب البنكي (أصل)",
    settlement_PleaseSelectBankAccount: "يرجى اختيار حساب بنكي",
    settlement_BankAccountNBE: "مثال: 'حساب بنكي - NBE'، #10100",
    settlement_CommissionIncome: "مثال: 'دخل العمولة'، #40100",
    settlement_VATPayable: "مثال: 'ضريبة القيمة المضافة المستحقة'، #20300",
    settlement_DebitAccountAsset: "حساب مدين (أصل)",
    settlement_OperatingAccount: "مثال: 'الحساب التشغيلي'، #10100",
    settlement_CreditAccountIncome: "حساب دائن (دخل)",
    settlement_FareRevenue: "مثال: 'إيرادات الأجرة'، #40100",
    settlement_CommissionExpense: "مثال: 'مصروف العمولة'، #50100",
    settlement_VATAssetAccount: "حساب أصول ضريبة القيمة المضافة",
    settlement_VATReceivable: "مثال: 'ضريبة القيمة المضافة المستحقة'، #10200",
    settlement_SelectSenderBankAccount: "اختر حساب بنك المرسل",
    settlement_SelectBeneficiaryBankAccount: "اختر حساب بنك المستفيد",
    settlement_AdditionalNotes: "ملاحظات إضافية",
    settlement_SuggestedERPJournalEntry: "اقتراح قيد يومية ERP",
    settlement_RecommendedJournalEntries: "قيود اليومية الموصى بها",
    settlement_SenderAccountMapping: "تعيين حساب المرسل",
    settlement_BeneficiaryAccountMapping: "تعيين حساب المستفيد",
    settlement_SettlementPeriod: "فترة التسوية",

    // Additional untranslated texts from wizard and table (only new unique keys)
    settlement_SelectSenderAndBeneficiary: "اختر المرسل والمستفيد",
    settlement_TransactionSummaryTitle: "ملخص المعاملات",
    settlement_SettlementTypeLabel: "نوع التسوية:",
    settlement_SenderOurCompanyLabel: "المرسل (شركتنا):",
    settlement_BeneficiaryLabel: "المستفيد:",
    settlement_PeriodLabelShort: "الفترة:",
    settlement_SelectChannelsToInclude: "اختر القنوات المراد تضمينها",
    settlement_NetSettlementZeroOrNegative: "صافي التسوية صفر أو سالب. يرجى تعديل القنوات المختارة للمتابعة.",
    settlement_MapFinancialAccountsForERP: "تعيين الحسابات المالية (لاقتراحات قيود ERP)",
    settlement_ERPJournalSuggestionsOnly: "اقتراحات قيود ERP فقط",
    settlement_ERPJournalSuggestionsDescription: "ستُستخدم هذه الحسابات لإنشاء اقتراح قيد اليومية لنظام ERP. هذا ليس نظام محاسبة كامل - مجرد اقتراحات للتصدير إلى نظام ERP الخاص بك.",
    settlement_SenderAccountsMwaslaTech: "حسابات المرسل (مواصلة تك)",
    settlement_BeneficiaryAccountsSuggestedForERP: "حسابات المستفيد (مقترحة لنظام ERP)",
    settlement_AutoFillFromDefaultERPMappings: "التعبئة التلقائية من تعيينات ERP الافتراضية",
    settlement_SuggestedJournalEntryForERP: "🧾 اقتراح قيد يومية لنظام ERP",
    settlement_ERPJournalSuggestionBalanced: "اقتراح قيد ERP (متوازن)",
    settlement_ERPJournalSuggestionDescription: "هذا مجرد اقتراح - وليس قيد محاسبي كامل. يُستخدم لإنشاء اقتراح قيد PDF لترحيل ERP.",
    settlement_FieldReference: "مرجع الحقل",
    settlement_Balanced: "✅ متوازن",
    settlement_JournalEntryExplanation: "شرح قيد اليومية",
    settlement_BankTransferDetailsTitle: "تفاصيل التحويل البنكي",
    settlement_SenderOurCompanyShort: "المرسل (شركتنا):",
    settlement_BeneficiaryPTOShort: "المستفيد (PTO):",
    settlement_LoadingBankAccounts: "جاري تحميل الحسابات البنكية...",
    settlement_OptionalNotesPlaceholder: "ملاحظات اختيارية لسجل المراجعة (مثال: تسوية شهرية صافية للربع الأول 2025)",
    settlement_ReviewSettlementTitle: "مراجعة التسوية",
    settlement_AmountAndCurrency: "المبلغ والعملة",
    settlement_SuggestedERPJournalEntrySenderTitle: "اقتراح قيد يومية ERP (المرسل)",
    settlement_SuggestedERPJournalEntryBeneficiaryTitle: "اقتراح قيد يومية ERP (المستفيد)",
    settlement_BankTransferNotesTitle: "ملاحظات التحويل البنكي",
    settlement_LoadingFinancialAccounts: "جاري تحميل الحسابات المالية...",
    settlement_FailedToLoadBankAccountsError: "فشل في تحميل الحسابات البنكية: ",

    // Missing translation keys
    settlement_VATLiabilityAccount: "حساب التزامات ضريبة القيمة المضافة",
    settlement_NetSettlement: "التسوية الصافية",
    settlement_UnknownAccount: "حساب غير معروف",
    settlement_ClearUnsettledDuesLiability: "إنهاء التزامات المستحقات غير المسددة",
    settlement_NetCashTransferredToPTO: "صافي النقد المحول إلى PTO",
    settlement_VATOnFeesTotal: "ضريبة القيمة المضافة على الرسوم (الإجمالي)",
    settlement_TotalFeesEarnedSummed: "إجمالي الرسوم المكتسبة (مجمعة)",
    settlement_NetCashReceivedFromSender: "صافي النقد المستلم من المرسل",
    settlement_CommissionExpenseTotal: "مصروف العمولة (الإجمالي)",
    settlement_VATOnCommissionTotal: "ضريبة القيمة المضافة على العمولة (الإجمالي)",
    settlement_RecognizeFareRevenueAndFeesTotal: "الاعتراف بإيرادات الأجرة والرسوم (الإجمالي)",
    settlement_PleaseSelectAllRequiredFields: "يرجى ملء جميع الحقول المطلوبة",
    settlement_DefaultBeneficiaryName: "ميدار",
    settlement_RecognizeFareRevenue: "الاعتراف بإيرادات الأجرة",
    settlement_MissingSettlementID: "معرف التسوية مفقود",

    // Additional translations for PDF and Settlement Details
    settlement_SettlementReport: "تقرير التسوية",
    settlement_SettlementIDLabel: "معرف التسوية",
    settlement_ACHReferenceNumber: "رقم مرجع ACH",
    settlement_TransferDateLabel: "تاريخ التحويل",
    settlement_NoBankTransferDetailsEntered: "لم يتم إدخال تفاصيل التحويل البنكي بعد",
    settlement_FinanceManager: "مدير المالية",
    settlement_GeneralManager: "المدير العام",
    settlement_NameLabel: "الاسم",
    settlement_DateLabel: "التاريخ",
    settlement_Signature: "التوقيع",
    settlement_AFCSettlementSystem: "نظام تسوية AFC",
    settlement_GeneratedOn: "تم الإنشاء في",
    settlement_AmountToSettleLabel: "المبلغ المطلوب تسويته",

    // Account names without codes
    settlement_UnsettledDues: "المستحقات غير المسددة",
    settlement_BankAccountAssetName: "الحساب البنكي",
    settlement_CommissionIncomeAccount: "دخل العمولة",
    settlement_VATPayableAccount: "ضريبة القيمة المضافة المستحقة",
    settlement_OperatingAccountName: "الحساب التشغيلي",
    settlement_FareRevenueAccount: "إيرادات الأجرة",
    settlement_CommissionExpenseAccount: "مصروف العمولة",
    settlement_VATReceivableAccount: "ضريبة القيمة المضافة المستحقة",

    // Description translations
    settlement_DescriptionLabel: "الوصف",

    // Status translations
    settlement_StatusLabel: "الحالة",
    settlement_StatusDraft: "مسودة",
    settlement_StatusConfirmed: "مؤكد",
    settlement_StatusCleared: "تم الإنهاء",
    settlement_StatusReversed: "تم العكس",
    settlement_StatusPending: "قيد الانتظار",

    // Currency translations
    settlement_CurrencyEGP: "ج.م",

    // Button translations
    settlement_Print: "طباعة",
    settlement_Download: "تحميل",
    settlement_DownloadTextPDF: "تحميل PDF نصي",

    // Yes/No translations
    settlement_Yes: "نعم",
    settlement_No: "لا",

    // Action translations
    settlement_ContinueAndConfirm: "متابعة وتأكيد",
    settlement_CompleteCurrentStepFirst: "يرجى إكمال الخطوة الحالية قبل الانتقال إلى الخطوة التالية",
    settlement_NoUnsettledTransactions: "هذه المنظمة ليس لديها معاملات غير مسددة. لا حاجة لتسوية.",

    Banks: "البنوك",
    OrganisationBanks: " بنوك الشركات",
    FinancialAccounts: "الحسابات المالية",

    BankNameAr: "اسم البنك (العربية)",
    BankNameEn: "اسم البنك (الإنجليزية)",
    BankNameEnglish: "اسم البنك (الإنجليزية)",
    BankNameArabic: "اسم البنك (العربية)",
    SwiftCode: "كود SWIFT",
    SearchBankNameSwiftCode: "اسم البنك، كود SWIFT",

    AddNewBank: "إضافة بنك جديد",
    BankAddedSuccessfully: "تم إضافة البنك بنجاح",
    AreYouSureDeleteBank: "هل أنت متأكد أنك تريد حذف هذا البنك؟",

    AddNewOrganisationBank: "إضافة بنك مؤسسة جديد",
    OrganisationBankAddedSuccessfully: "تم إضافة بنك المؤسسة بنجاح",
    AddOrganisationBank: "إضافة بنك مؤسسة",
    AreYouSureDeleteOrganisationBank: "هل أنت متأكد أنك تريد حذف بنك المؤسسة هذا؟",
    OrganisationNameEnglish: "اسم المؤسسة",

    // AddEntity Component
    SelectOption: "اختر خيار",
    SelectDependencyFirst: "يرجى تحديد الحقل المطلوب أولاً",

    // Organisation Bank Fields
    AccountName: "اسم الحساب",
    AccountNumber: "رقم الحساب",
    IBAN: "رقم الآيبان",
    BranchName: "اسم الفرع",
    BranchAddress: "عنوان الفرع",
    BeneficiaryEmail: "البريد الإلكتروني للمستفيد",
    BeneficiaryMobile: "رقم هاتف المستفيد",
    Organisation: "المؤسسة",
    Bank: "البنك",
    FinancialAccount: "الحساب المالي",
    SearchOrganisationBankPlaceholder: "البحث باسم الحساب، الرقم، الآيبان، أو الفرع",

    // Financial Accounts
    AddNewFinancialAccount: "إضافة حساب مالي جديد",
    FinancialAccountAddedSuccessfully: "تم إضافة الحساب المالي بنجاح",
    AreYouSureDeleteFinancialAccount: "هل أنت متأكد أنك تريد حذف هذا الحساب المالي؟",
    SearchFinancialAccountPlaceholder: "البحث بالاسم، الوصف، رقم الحساب",
    AccountType: "نوع الحساب",
    ParentAccount: "الحساب الأب",
    FinancialAccountInfo: "معلومات الحساب المالي",
    BackToFinancialAccounts: "العودة إلى الحسابات المالية",
    EditFinancialAccount: "تعديل الحساب المالي",
    MyAccount: "حسابي",

    // ViewEntity Component
    BankInfo: "معلومات البنك",
    OrganisationBankInfo: "معلومات بنك المؤسسة",
    BankName: "اسم البنك",
    CreatedAt: "تاريخ الإنشاء",
    UpdatedAt: "تاريخ التحديث",
    BackToBanks: "العودة إلى البنوك",
    BackToOrganisationBanks: "العودة إلى بنوك المؤسسات",
    DeletedSuccessfully: "تم الحذف بنجاح",
    Deleting: "جاري الحذف...",

    // EditEntity Component
    EditBank: "تعديل البنك",
    EditOrganisationBank: "تعديل بنك المؤسسة",
    UpdatedSuccessfully: "تم التحديث بنجاح",

    // Permission Messages
    YouDontHavePermissionToAccessThisPage: "ليس لديك صلاحية للوصول إلى هذه الصفحة",
    TransferBalance: "تحويل الرصيد",
    // Transfer Balance Form
    FromSourceCard: "من",
    ToDestinationCard: "إلى",
    EnterCardSerial: "أدخل الرقم التسلسلي للبطاقة",
    GetInfo: "الحصول على المعلومات",
    FromSourceCardInfo: "معلومات البطاقة المصدر",
    ToDestinationCardInfo: "معلومات بطاقة الوجهة",
    Issued: "صادرة",
    Expired: "منتهية الصلاحية",
    CurrentBalance: "الرصيد الحالي",
    Note: "ملاحظة",
    EnterAmount: "أدخل المبلغ",
    Transfer: "تحويل",
    Blacklisted: "محظورة",
    BlacklistSourceCard: "حظر البطاقة المصدر",
    BlacklistFullTransferNote: "إذا تم اختيار الحظر، يجب تحويل كامل رصيد البطاقة المصدر",
    BlacklistNote: "ملاحظة الحظر (اختياري)",
    TransferAmount: "المبلغ ",
    UseAllBalance: "تحويل كامل الرصيد",
    PleaseEnterCardSerial: "الرجاء إدخال الرقم التسلسلي للبطاقة",
    ModeBalanceTransfer: "تحويل رصيد",
    ModeCardReplacement: "استبدال بطاقة",
    ModeBalanceTransferHint: "يتم تحويل المبلغ المدخل فقط. يبقى منتج التعريفة على البطاقة المصدر.",
    ModeReplacementHint: "يتم تحويل كامل الرصيد، وحظر البطاقة المصدر، وانتقال أي منتج تعريفة نشط أو معلّق إلى البطاقة الوجهة.",
    CardOwner: "مالك البطاقة",
    NotLinkedToAnyUser: "غير مرتبطة بأي مستخدم",
    FareProduct: "منتج التعريفة",
    NoFareProduct: "لا يوجد منتج تعريفة",
    ActivePendingLabel: "نشط/معلّق",
    GuardOrgMismatch: "يجب أن تنتمي البطاقتان إلى نفس جهة الإصدار.",
    GuardBothOwned: "هاتان البطاقتان تخصان راكبين مختلفين. التحويل غير مسموح.",
    GuardReplacementDestNoOwner: "البطاقة الوجهة غير مرتبطة بأي مستخدم. اطلب من الراكب فك ارتباط البطاقة القديمة وربط البطاقة الجديدة من التطبيق، ثم أعد المحاولة.",
    GuardReplacementProductDestNoOwner: "البطاقة المصدر تحمل منتج تعريفة، ويجب أن تكون البطاقة الوجهة مرتبطة بمستخدم لاستقباله.",
    GuardReplacementDestHasProduct: "البطاقة الوجهة تحمل بالفعل منتج تعريفة. لا يمكن لبطاقة واحدة أن تحمل أكثر من منتج.",
    GuardBalanceSourceProductNoOwner: "هذه البطاقة تحمل منتج تعريفة ولكنها غير مرتبطة بأي مستخدم. يجب إصلاح ارتباطها أولًا.",
    GuardBalanceFullAmountWarning: "تحويل كامل الرصيد سيترك منتج التعريفة على بطاقة بلا رصيد. استخدم استبدال البطاقة، أو حوّل مبلغًا أصغر.",
    TransferEligibility: "نقل أهلية وسيلة الدفع",
    TransferEligibilityWarning: "سيتم استبدال أي سجلات أهلية موجودة على بطاقة الوجهة وتتطابق مع بطاقة المصدر.",
    AlreadyHasActiveInstance: "يوجد منتج نشط/معلق",
    AlreadyHasAnyActiveFareProduct: "هذه البطاقة لديها بالفعل عرض تذكرة نشط أو معلق",
    MissingRequiredDocuments: "مستندات مطلوبة غير متوفرة",
    YourCurrentBalance: "رصيدك الحالي",
    BalanceAfterPurchase: "الرصيد بعد الشراء",
    AssignedRoutes: "المسارات المخصصة",
    BuyFareProductLogicHelp: 'منتجات التعريفة هذه متاحة لمجموعة الركاب الخاصة بك.\n\n• المسارات المخصصة: تعرض جميع المسارات المتاحة لك، مجمعة من عدة تخصيصات.\n• صلاحية التخصيص: تعرض تاريخ بداية ونهاية أقدم وأحدث تخصيص متاح لك.\n\nملاحظة: عند استخدام بطاقتك في الحافلة، سيقوم النظام بالتحقق بصرامة من تواريخ الصلاحية الدقيقة لكل مسار على حدة.',
    CancelledAt: "تاريخ الإلغاء",
    CardInfoRetrievedSuccessfully: "تم استرجاع معلومات البطاقة بنجاح",
    CardDoesNotExist: "البطاقة غير موجودة",
    FailedToGetCardInfo: "فشل في الحصول على معلومات البطاقة",
    PleaseEnterBothCardSerials: "الرجاء إدخال الرقم التسلسلي لكلا البطاقتين",
    PleaseGetCardInfoFirst: "الرجاء الحصول على معلومات البطاقة أولاً",
    PleaseEnterAmount: "الرجاء إدخال المبلغ أو اختيار استخدام كامل الرصيد",
    BlacklistRequiresFullTransfer: "إذا تم اختيار الحظر، يجب تحويل كامل رصيد البطاقة المصدر",
    TransferSuccessful: "تم التحويل بنجاح",
    TransferFailed: "فشل التحويل",
    CardBlacklistedTransferError: "هذا البطاقة محظورة ولا يمكن استخدامها في عملية تحويل الرصيد",
    DiscountBandAssignment: "تعيينات المنتجات والعروض",
    AddNewDiscountBandAssignment: "إضافة تعيين نطاق خصم",
    UpdateDiscountBandAssignment: "تحديث تعيين نطاق خصم",
    DiscountBandAssignmentInfo: "معلومات تعيين نطاق الخصم",
    SearchDiscountBandAssignmentPlaceholder: "البحث باسم خطة الخصم، الكود، أو اسم مجموعة وسائط الدفع",
    AreYouSureDeleteDiscountBandAssignment: "هل أنت متأكد من حذف هذا التعيين؟",
    DiscountBandAssignmentCreatedSuccessfully: "تم إنشاء تعيين نطاق الخصم بنجاح",
    DiscountBandAssignmentUpdatedSuccessfully: "تم تحديث تعيين نطاق الخصم بنجاح",
    Priority: "الأولوية",
    BandDateValidity: "صلاحية تاريخ النطاق",
    TimeWindow: "النافذة الزمنية",
    Value: "القيمة",
    BandDetails: "تفاصيل منتج التعريفة",
    DateWindow: "نافذة التاريخ",
    FixedAmount: "مبلغ ثابت",
    Open: "مفتوح",
    TotalFareMediaInGroup: "إجمالي وسائط الدفع في المجموعة",
    TotalUsersInGroup: "إجمالي المستخدمين في المجموعة",
    UniqueFareMediaWithOffer: "عدد وسائط الدفع التي اشترت هذا العرض",
    PurchasedOffersByGroup: "إجمالي العروض المشتراة",
    Analysis: "تحليل",
    ViewPriorityReference: "عرض مرجع الأولوية",
    HidePriorityReference: "إخفاء مرجع الأولوية",
    NoPriorityAssignmentsFound: "لا توجد تعيينات أخرى لهذا النطاق.",
    Actions: "إجراءات",
    PriorityHint: "يُستخدم لحسم التعادل عندما تُطبّق تعيينات متعددة نفس قيمة الخصم على رحلة واحدة.\n\nيفوز التعيين ذو رقم الأولوية الأصغر.\n\nمثال: الأولوية 10 تتقدم على الأولوية 100.\n\nالقيمة الافتراضية هي 100.",
    CurrentRecord: "الحالي",
    Active: "نشط",
    Pending: "قيد الانتظار",
    Cancelled: "ملغى",
    DiscountBandsCount: "عدد نطاقات الخصم",
    FareProductFieldsIncompleteWarn: "مطلوب لإعداد عرض التذكرة.",
    PleaseSelectOrgAndDate: "الرجاء اختيار المنظمة وتاريخ البدء.",
    AssignmentLinkedToInactiveBand: 'تحذير: باقة الخصم الأساسية غير مفعلة. هذا التعيين محذوف ولن يعمل!',
    BandDateCascadeWarning: "ملاحظة: إذا قمت بتقليص التواريخ، سيقوم النظام تلقائياً بضبط تواريخ التعيينات النشطة لتتطابق معها. ولكن إذا كان هناك أي تعيين يقع بالكامل خارج التواريخ الجديدة، سيتم منع التعديل لحماية البيانات.",
    ExportingPleaseWait: "جاري استخراج البيانات... قد يستغرق هذا بضع لحظات",
    ExportFailed: "فشل استخراج البيانات. الرجاء المحاولة مرة أخرى.",
    obcTime: "وقت الجهاز",
    obcTimeFrom: "وقت الجهاز من",
    obcTimeTo: "وقت الجهاز إلى",
    discountBandAssignments: "تعيينات باقة الخصم",
    discountApplied: "الخصم المطبق",
    createdAtFromDate: "تاريخ الإنشاء من",
    createdAtToDate: "تاريخ الإنشاء إلى",
    obcFromDate: "وقت الجهاز من",
    obcToDate: "وقت الجهاز إلى",
    BuyPass: "شراء منتج تعريفة",
    SelectPass: "اختر منتج التعريفة",
    NoEligiblePasses: "لا توجد منتجات تعريفة متاحة",
    Buy: "شراء",
    // Restored missing keys
    Zoning: 'التقسيم',
    confirmdeleteMessage: 'هل أنت متأكد من انك تريد حذف',
    createdBy: 'أنشئت بواسطة',
    updatedBy: 'تم التحديث بواسطة',
    Status: 'الحالة',
    NoAccess: 'لا يوجد صلاحيات',
    FullAccess: 'التحكم الكامل',
    ReadOnly: 'قراءة فقط',
    superadmin: 'مدير عام',
    amount: 'المبلغ',
    noorganization: 'لا توجد شركات',
    vehicletype: 'نوع المركبة',
    vehicleclass: 'فئة المركبة',
    Routes: "المسارات",
    SearchByName: "البحث بالأسم , الرمز ",
    Show: " عرض   ",
    Login: "تسجيل دخول",
    Logout: "تسجيل خروج",
    ArabicName: "اللأسم بالعربية ",
    EnglishName: "اللأسم بالأنجليزية ",
    Organization: "الشركة",
    Groups: "المجموعات",
    Code: " الرمز",
    Username: "إسم المستخدم",
    Password: "كلمة السر",
    RouteInfo: "بيانات المسار",
    Axes: "قائمة المحاور",
    Cash: "نقدي",
    Card: "بطاقة",
    Stops: "المحطات",
    Save: "حفظ",
    Edit: "تعديل",
    Stop: "محطة",
    PageNotFound: "الصفحة غير موجودة ",
    Back: " الرجوع",
    Filter: "تصفية",
    Apply: "بحث",
    Reset: "إعادة تعيين",
    Delete: "حذف",
    Name: "الأسم",
    Cancel: "تراجع",
    Add: "إضافة",
    discountAmount: 'الخصم المطبق',
    yes: "نعم",
    no: "لا",
    Update: "تعديل",
    ConfirmPassword: "أعد ادخال كلمة السر",
    StartDate: "من تاريخ ",
    EndDate: "الي تاريخ ",
    vat: "ضريبة القيمة المضافة",
    paidAmount: 'المبلغ المدفوع',
    Balance: "الرصيد",
    priority: "الأولوية",
    validity: "الصلاحية",
    Type: "النوع",
    Route: "مسار",
    Group: "مجموعة",
    DiscountBandAssignmentsCount: "عدد تعيينات نطاق الخصم",
    createdAt: "تاريخ الإنشاء (وقت الخادم)",
    AvailableRoutes: "المسارات المتاحة",
    SelectedRoutes: "المسارات المختارة",
    FareProducts: 'الاشتراكات',
    Promotions: 'العروض',
    AddNewPromotion: 'إضافة عرض جديد',
    AddNewFareProduct: 'إضافة اشتراك جديد',
    AreYouSureDeletePromotion: 'هل أنت متأكد من حذف هذا العرض؟',
    AreYouSureDeleteFareProduct: 'هل أنت متأكد من حذف هذا الاشتراك؟',
    PromotionInfo: 'معلومات العرض',
    FareProductInfo: 'معلومات الاشتراك',
    EditPromotion: 'تعديل العرض',
    EditFareProduct: 'تعديل الاشتراك',
    PromotionCreatedSuccessfully: 'تم إنشاء العرض بنجاح',
    FareProductCreatedSuccessfully: 'تم إنشاء الاشتراك بنجاح',
    PromotionUpdatedSuccessfully: 'تم تحديث العرض بنجاح',
    FareProductUpdatedSuccessfully: 'تم تحديث الاشتراك بنجاح',
    FareProductEmptyFieldsWarningTitle: 'حقول الاشتراك غير مكتملة',
    FareProductEmptyFieldsWarningMsg: 'ترك سعر الشراء، مدة العقد (أيام)، الحد الأقصى للإنفاق، والحد الأقصى للرحلات فارغة (أو أي منها) سيؤدي إلى حفظ هذا السجل كعرض وليس كاشتراك، وسيتم مسح المستندات المختارة.',
    ContinueAsPromotion: 'المتابعة كعرض',
    GoBackFillFields: 'الرجوع وملء الحقول',
    ConvertToFareProduct: 'تحويل إلى اشتراك',
    ConvertToPromotion: 'تحويل إلى عرض',
    ConvertToPromotionWarningTitle: 'تحويل الاشتراك إلى عرض',
    ConvertToPromotionWarningMsg: 'ملاحظة: بتحويل هذا الاشتراك إلى عرض، سيتم إعادة تعيين أو حذف القيم التالية: سعر الشراء، مدة العقد (أيام)، الحد الأقصى للإنفاق، الحد الأقصى للرحلات، مشغّل التفعيل، يتطلب مستندات، وجميع المستندات المختارة.',
    ContinueConvertToPromotion: 'متابعة وتحويل',
    GoBackKeepFareProduct: 'الرجوع',

    // ── Configuration → Fare Media reference data ──────────────────────────
    FareMediaIssuers: 'جهات إصدار وسائط الدفع',
    FareMediaIssuer: 'جهة الإصدار',
    AddNewFareMediaIssuer: 'إضافة جهة إصدار',
    EditFareMediaIssuer: 'تعديل جهة الإصدار',
    FareMediaIssuerInfo: 'بيانات جهة الإصدار',
    SearchFareMediaIssuerPlaceholder: 'ابحث بالاسم أو الهاتف أو البريد الإلكتروني أو العنوان...',
    AreYouSureDeleteFareMediaIssuer: 'هل أنت متأكد من حذف جهة الإصدار هذه؟',
    FareMediaIssuerCreatedSuccessfully: 'تم إنشاء جهة الإصدار بنجاح',
    FareMediaIssuerUpdatedSuccessfully: 'تم تحديث جهة الإصدار بنجاح',

    FareMediaIssuerOrganizations: 'ربط جهات الإصدار بالمؤسسات',
    AddNewFareMediaIssuerOrganization: 'ربط جهة إصدار بمؤسسة',
    EditFareMediaIssuerOrganization: 'تعديل ربط جهة الإصدار',
    FareMediaIssuerOrganizationInfo: 'بيانات ربط جهة الإصدار',
    SearchFareMediaIssuerOrganizationPlaceholder: 'ابحث باسم جهة الإصدار أو المؤسسة...',
    AreYouSureDeleteFareMediaIssuerOrganization: 'هل أنت متأكد من حذف هذا الربط؟',
    FareMediaIssuerOrganizationCreatedSuccessfully: 'تم ربط جهة الإصدار بالمؤسسة بنجاح',
    FareMediaIssuerOrganizationUpdatedSuccessfully: 'تم تحديث ربط جهة الإصدار بنجاح',

    FareMediaTypes: 'أنواع وسائط الدفع',
    AddNewFareMediaType: 'إضافة نوع وسيلة دفع',
    EditFareMediaType: 'تعديل نوع وسيلة الدفع',
    FareMediaTypeInfo: 'بيانات نوع وسيلة الدفع',
    SearchFareMediaTypePlaceholder: 'ابحث في أنواع وسائط الدفع...',
    AreYouSureDeleteFareMediaType: 'هل أنت متأكد من حذف نوع وسيلة الدفع هذا؟',
    FareMediaTypeCreatedSuccessfully: 'تم إنشاء نوع وسيلة الدفع بنجاح',
    FareMediaTypeUpdatedSuccessfully: 'تم تحديث نوع وسيلة الدفع بنجاح',

    // shared field labels
    Address: 'العنوان',
    AssignedOrganisations: 'المؤسسات المرتبطة',
    IssuedFareMedia: 'البطاقات الصادرة',
    IsOld: 'قديم',
    IsTest: 'اختباري',
    IsOldHint: 'يشير إلى نوع بطاقة تم استبداله. يُحتفظ به لتظل البطاقات الحالية صالحة، ولا يُستخدم لدفعات جديدة.',
    IsTestHint: 'يشير إلى نوع مخصص للاختبار فقط. البطاقات الاختبارية مستثناة من التقارير التشغيلية.',

    // organizations: extra details (Express API)
    orgAdditionalDetails: 'تفاصيل إضافية',
    orgAdditionalDetailsIntro:
      'تم إنشاء المؤسسة. حدد تفاصيلها الإضافية أدناه، أو تخطَّ هذه الخطوة وأكملها لاحقًا من شاشة التعديل.',
    orgSkipForNow: 'تخطي الآن',
    orgExtraDetailsSaved: 'تم حفظ التفاصيل الإضافية للمؤسسة بنجاح',
    orgExtraDetailsSaveFailed:
      'تم تحديث المؤسسة، لكن فشل حفظ التفاصيل الإضافية',
    orgExtraDetailsLoadFailed:
      'تعذر تحميل التفاصيل الإضافية. يمكنك مع ذلك تعديل الأسماء والحالة.',
    orgCode: 'كود المؤسسة',
    orgShowHint: 'عرض التلميح',
    orgKind: 'نوع المؤسسة',
    orgKindHint: 'المؤسسة إما شركتي أو مشغّل نقل عام (PTO)، وليس الاثنين معًا.',
    orgKindMyCompany: 'شركتي',
    orgKindPto: 'مشغّل نقل عام (PTO)',
    orgIsSuper: 'مؤسسة رئيسية',
    orgMaxDevices: 'الحد الأقصى للأجهزة',
    orgCurrentDevices: 'عدد الأجهزة الحالي',
    orgChargingBackendUrl: 'رابط الخادم الأساسي للشحن',
    orgThresholdValue: 'قيمة الحد الأدنى',
    orgThresholdHint:
      'مهم: إذا انخفض رصيد البطاقة عن هذه القيمة يتم إدراج البطاقة في القائمة السوداء حتى يتم شحنها مرة أخرى. ينطبق على البطاقات أونلاين وأوفلاين.',
    orgServiceDayCutoff: 'وقت نهاية يوم الخدمة (UTC)',
    orgServiceDayCutoffHint: 'هذا الوقت بتوقيت UTC وليس التوقيت المحلي.',
    orgCurrency: 'العملة',
    orgInvalidMaxDevices: 'أدخل عددًا صحيحًا بين 0 و 99999999',
    orgInvalidChargingUrl: 'أدخل رابط http(s) صالحًا (بحد أقصى 255 حرفًا)',
    orgInvalidThreshold: 'أدخل رقمًا صالحًا',
    orgInvalidCutoff: 'أدخل وقتًا صالحًا بتوقيت UTC (HH:mm:ss)',
    orgInvalidCurrency: 'أدخل رمز عملة من 3 أحرف، مثل EGP',
  },
};
